<template>
    <div class="con-list base-info">
		<div
            v-for="(item,index) in applyData.hrAttachs"
            class="attach-item"
            :key="index">
            <van-field
                label="序号"
                :value='index+1'
                readonly
            />
            <van-field
                class="select"
                is-link
                readonly
                clickable
                v-model="item.pageModualDesc"
                label="附件名称"
                v-if="!isDetail"
                @click="selectValue(index)"/>
            <van-field
                readonly
                v-else
                :value="item.pageModual | transferVal"
                label="附件名称"/>
            <van-field
                label="附件"
                readonly>
                <template #input>
                    <div
                        class="field-con"
                        @click="downloadFile(item)"
                        v-if="item.attachSaveName">{{item.attachSaveName}}</div>
                    <div v-else>
                        <el-upload
                            :with-credentials='true'
                            :headers="headers"
                            :data="{saveFlag: 'N'}"
                            :show-file-list='false'
                            :before-upload='handleBeforeUpload'
                            :on-success='handleFileUpload.bind(this, index)'
                            :on-error='handleFileError'
                            accept='.jpg,.jpeg,.png,.gif,.bmp,.pdf,.JPG,.JPEG,.PBG,.GIF,.BMP,.PDF'
                            :action="attachUrl">
                            <div class="u-upload-btn">
                                <img
                                    src="https://image.guazistatic.com/gz01200517/15/46/f370bdfe4dd9bd168e955780340a06da.png"
                                    class="upload">
                            </div>
                        </el-upload>
                    </div>
                    <van-popup v-model="item.showPicker"  position="bottom">
                        <van-picker
                            title="请选择"
                            show-toolbar
                            :value-key="keyValue"
                            v-model="item.pageModual"
                            :columns="[
                                // {
                                //     label: '背调授权书',
                                //     value: 'back_check',
                                // }, 
                                {
                                    label: '其他',
                                    value: 'oth',
                                }
                            ]"
                            @confirm="onConfirm"
                            @cancel="item.showPicker = false"/>
                    </van-popup>
                </template>
            </van-field>
            <van-field
                label="删除"
                v-if="!isDetail"
                readonly>
                <template #input>
                    <span class="el-icon-delete filed-switch" @click='delLine(index, item)'></span>
                </template>
            </van-field>
        </div>
        <div class="con-filed txt-right" v-if="!isDetail">
            <span
                class="add-icon"
                v-if="!isDetail"
                @click="addNewFile">新增附件</span>
        </div>
	</div>
</template>

<script>
import { getBgCheck, attachUrl, downloadByUrl, downloadAttach } from '@/network'
import { Notify } from 'vant'
import { deviceInfoReady } from '@/util'
import NativeApi from 'native-api'

export default {
    name: 'm-attach',
    props: ['applyData', 'isDetail'],
    data() {
        return {
            attachUrl,
            keyValue: 'label', 
            currentIndex: 0,
            headers: {},
        }
    },
    filters: {
        transferVal(value) {
            return {
                // 'back_check': '背调授权书',
                'oth': '其他',
            }[value]
        },
    },
    mounted() {
        this.setHeader()
    },
    methods: {
        onConfirm(obj){
            let index = this.currentIndex
            this.$set(this.applyData.hrAttachs[index], 'pageModualDesc', obj.label)
            this.$set(this.applyData.hrAttachs[index], 'pageModual', obj.value)
            this.$set(this.applyData.hrAttachs[index], 'showPicker', false)
        },
        selectValue(index) {
            this.$set(this.applyData.hrAttachs[index], 'showPicker', true)
            this.currentIndex = index
        },
        addNewFile() {
            this.applyData.hrAttachs.push({
                pageModual: 'oth',
                pageModualDesc: '其他',
				attachModule: 'outside',
				delFlag: '0',
			})
        },
        delLine(index, data) {
			this.applyData.hrAttachs.splice(index, 1)
        },
        handleBeforeUpload() {
            // this.$parent.loading = true
            this.$emit('changeLoading', true)
		},
        handleFileUpload(index, res) {
            this.$emit('changeLoading', false)
			let { data, message } = res
            if (res.code !== 'S00000') {
                Notify({ type: 'danger', message })
                return
            }
            Notify({ type: 'success', message: '上传成功' })
			this.$set(this.applyData.hrAttachs[index], 'attachSaveName', data.fileName)
			this.$set(this.applyData.hrAttachs[index], 'attachSavePath', data.viewUrl)
			this.$set(this.applyData.hrAttachs[index], 'fileUniqueId', data.fileId)
			this.$set(this.applyData.hrAttachs[index], 'downloadUrl', data.downloadUrl)
		},
		handleFileError() {
            this.$emit('changeLoading', false)
            Notify({ type: 'danger', message: '上传失败' })
        },
        setHeader() {
            deviceInfoReady().then((info) => {
                this.headers = {
                    'token': info.token ? `${info.token}` : '',
                    'clientType': 'APP',
                }
            })
        },
        downloadFile(data) {
			if (data.downloadUrl) {
                NativeApi.invoke('downloadFile', {
                    fileUrl: data.downloadUrl,
                    fileName: data.attachSaveName,
                })
			} else {
				this.downloadAttach({
					attachId: data.attId,
				}, data.attachSaveName)
			}
		},
		async downloadAttach(params, fileName) {
			let res = await downloadAttach(params).catch(() => {})
            if (!res) return
            NativeApi.invoke('downloadFile', {
                fileUrl: res.data.data,
                fileName,
            })
		},
    },
}
</script>

<style lang="scss" scope>
.filed-switch{
    margin-right: 16px;
}
.field-con{
    margin-right: 16px;
    color: #11ca78;
    cursor: pointer;
}
.u-upload-btn{
    margin-right: 16px;
    padding-top: 4px;
}
.upload{
    width: 30px;
}
.attach-item{
    margin-bottom: 10px;
    border-bottom: 1px solid #ebedf0;
}
.add-icon{
    display: inline-block;
    width: 88px;
    text-align: center;
    height: 32px;
    line-height: 32px;
    color: #fff;
    font-size: 14px;
    cursor: pointer;
    background: #05B555;
    border-radius: 8px;
}
</style>